export default function TabPanelFactory(componentConfig) {
  const options = componentConfig.options || {};

  return {
    ...options,
    selectedIndex: options.selectedIndex || 0
  };
}
